export const CONSEIL_URL_GOUV_FR = 'https://www.chezsoidabord.ca/fthbi/first-time-homebuyer-incentive';
export const CONSEIL_URL_GOUV_EN = 'https://www.placetocallhome.ca/fthbi/first-time-homebuyer-incentive';
export const CAISSE_NON_ELIGIBLE_LIEN_QC_FR = 'https://www.desjardins.com/qc/fr/hypotheque/acheter-maison.html';
export const CAISSE_NON_ELIGIBLE_LIEN_QC_EN = 'https://www.desjardins.com/qc/en/mortgage/first-time-home-buyer.html';
export const CAISSE_NON_ELIGIBLE_LIEN_ON_FR = 'https://coop.desjardins.com/oc/fr/hypotheque/acheter-maison.html';
export const CAISSE_NON_ELIGIBLE_LIEN_ON_EN = 'https://coop.desjardins.com/oc/en/mortgage/first-time-home-buyer.html';
export const OFFRE_ACCEDANTS_URL_FR =
  'https://www.desjardins.com/particuliers/projets-evenements/financer-habitation/acheter-maison/#remise-argent';
export const OFFRE_ACCEDANTS_URL_EN =
  'https://www.desjardins.com/ca/personal/goals-life-events/owning-home/buying-home/#cash-back';
export const ASSURANCE_PRET_URL_FR =
  'https://www.desjardins.com/particuliers/assurances/assurances-pret-marge-solde-credit/assurance-pret/index.jsp';
export const ASSURANCE_PRET_URL_EN =
  'https://www.desjardins.com/ca/personal/insurance/loan-credit-insurance/loan-insurance/index.jsp';

export const CAPACITE_CELLIAP_URL_FR =
  'https://www.desjardins.com/particuliers/epargne-placements/regimes-fiscalement-avantageux/celiapp/index.jsp';
export const CAPACITE_CELLIAP_URL_EN =
  'https://www.desjardins.com/ca/personal/savings-investment/tax-sheltered-plans/fhsa/index.jsp';

export const CAPACITE_RAP_URL_FR = 'https://www.desjardins.com/fr/hypotheque/rap.html';
export const CAPACITE_RAP_URL_EN = 'https://www.desjardins.com/en/mortgage/home-buyers-plan.html';
